import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import ApprovalPanel from './ApprovalPanel';
window.mountApprovalPanel = function mountApprovalPanel(containerId, props) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('ApprovalPanel: container not found:', containerId);
        return { unmount: () => { }, get api() { return null; } };
    }
    const apiRef = createRef();
    const root = createRoot(container);
    root.render(React.createElement(ApprovalPanel, { ...props, ref: apiRef }));
    return {
        unmount: () => root.unmount(),
        get api() { return apiRef.current; },
    };
};
